import { Flex, Spinner, Text } from '@chakra-ui/react';
import React from 'react';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading data...',
  size = 'lg',
}) => {
  return (
    <Flex py={8} align="center" justify="center" gap={4} flexDir="column">
      <Spinner size={size} />
      {message && <Text mt={4}>{message}</Text>}
    </Flex>
  );
};
